import { finalize, Observable, Subscription, switchMap, tap } from 'rxjs';
import { HttpMemberService } from '../../../service/http-member.service';
import { EmployerDto, MemberDto, ResultListDto } from '../../../service/dto';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HierarchyService } from '../../../service/hierarchy.service';
import {
	Filter,
	OnTableChange,
	TableColumn,
} from '../../../components/table/table.component';

@Component({
	selector: 'app-member-list',
	standalone: false,
	templateUrl: './member-list.component.html',
	styleUrl: './member-list.component.scss',
})
export class MemberListComponent implements OnInit, OnDestroy {
	@Input() employerId?: number;
	data?: ResultListDto<MemberDto>;
	pageIndex = 1;
	pageSize = 30;
	subscription = new Subscription();
	appliedFilters: any = {};

	loading = false;
	filters: Filter[] = [
		{
			label: 'ID Number',
			name: 'idNumber',
			type: 'Text',
			format: '^\\w+$',
		},
		{ label: 'Name', name: 'name', type: 'Text', format: '^\\w.*$' },
		{ label: 'Surname', name: 'surname', type: 'Text', format: '^\\w.*$' },
		{ label: 'Msisdn', name: 'msisdn', type: 'Text', format: '^\\w.*$' },
		{
			label: 'Email Address',
			name: 'emailAddress',
			type: 'Text',
			format: '^\\w.*$',
		},
		// { label: 'Membership Number', name: 'membershipNumber', type: 'Text', format: '^\\w.*$' }
		{
			label: 'Personnel Number',
			name: 'personnelNumber',
			type: 'Text',
			format: '^\\w.*$',
		},
	];
	columnRef: TableColumn[] = [
		{ title: 'Name', property: 'name' },
		{ title: 'Last Name', property: 'surname' },
		{ title: 'Msisdn', property: 'msisdn' },
		{ title: 'Email Address', property: 'emailAddress' },
		{ title: 'ID Number', property: 'idNumber' },
		{ title: 'Date of Birth', property: 'dateOfBirth' },
		{ title: 'Date of Death', cellRef: 'refDateOfDeath' },
	];

	constructor(
		private httpService: HttpMemberService,
		private hierarchyService: HierarchyService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
	) {}
	ngOnInit(): void {
		if (this.employerId) {
			this.appliedFilters['employerId'] = this.employerId;
		}
		this.appliedFilters['pageIndex'] = this.pageIndex;
		this.appliedFilters['pageSize'] = this.pageSize;

		console.log('Init', this.appliedFilters);

		this.subscription.add(
			this.hierarchyService.hierarchy$
				.pipe(
					tap(() => (this.loading = true)),
					switchMap(() =>
						this.httpService.findMembers(
							this.appliedFilters,
							this.pageIndex,
							this.pageSize,
						),
					),
				)
				.subscribe({
					next: (result) => {
						this.data = result;
						this.loading = false;
					},
					error: (err) => {
						this.loading = false;
					},
				}),
		);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doView(input: MemberDto) {
		this.router.navigate(['/member', input.id, 'view']);
	}
	doFetchResults(input: OnTableChange) {
		const appliedFilters = {
			idNumber: input.filters.filter((i) => i.name == 'idNumber')[0]
				?.value,
			name: input.filters.filter((i) => i.name == 'name')[0]?.value,
			surname: input.filters.filter((i) => i.name == 'surname')[0]?.value,
			msisdn: input.filters.filter((i) => i.name == 'msisdn')[0]?.value,
			emailAddress: input.filters.filter(
				(i) => i.name == 'emailAddress',
			)[0]?.value,
			personnelNumber: input.filters.filter(
				(i) => i.name == 'personnelNumber',
			)[0]?.value,
			employerId: this.employerId,
			pageIndex: input.pageIndex,
			pageSize: input.pageSize,
		};
		console.log('Before', this.appliedFilters);
		console.log('After', appliedFilters);
		if (
			JSON.stringify(this.appliedFilters) ==
			JSON.stringify(appliedFilters)
		) {
			return;
		}
		this.appliedFilters = appliedFilters;

		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = true;

		this.httpService
			.findMembers(this.appliedFilters, this.pageIndex, this.pageSize)
			.pipe(
				finalize(() => {
					this.loading = false;
				}),
			)
			.subscribe((result) => {
				this.data = result;
			});
	}
}
